import { getBaseUrl } from '../lib/helpers'
import { LOGO_ENDPOINT } from './logo-constants'
import { ClaimDataLogoRequest } from './types'

class LogoService {
    static logoInstance: LogoService | null = null

    static getInstance() {
        if (LogoService.logoInstance === null) {
            LogoService.logoInstance = new LogoService()
        }

        return this.logoInstance
    }

    async getLogo(claimDataLogoRequest: ClaimDataLogoRequest) {
        try {
            const response = await fetch(
                `${getBaseUrl()}${LOGO_ENDPOINT}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(claimDataLogoRequest),
                credentials: 'omit'
            })
            if (!response.ok) {
                console.log(`Response: ${JSON.stringify(response)}`)
                throw Error('Error retrieving logo information')
            }

            const data = await response.json()
            return data
        } catch (err) {
            console.log(`LogoService Error: ${err}`)
            return null
        }
    }
}

export { LogoService }
